import { NgTemplateOutlet } from '@angular/common';
import { AfterViewInit, Component, computed, EmbeddedViewRef, inject, input, OnDestroy, output, TemplateRef, viewChild } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';

import { NzDrawerModule, NzDrawerRef, NzDrawerService } from 'ng-zorro-antd/drawer';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzContextMenuService, NzDropDownModule, NzDropdownMenuComponent } from 'ng-zorro-antd/dropdown';

import { IVzMenuItem } from '@models/shared/vz-menu-item';

@Component({
    template: `
        <nz-dropdown-menu #ddMenu="nzDropdownMenu">
            @if (singleItem(); as item) {
                <ul nz-menu>
                    @if (isTpl(menuTitle())) {
                        <span class="vz-menu-title" style="padding: 0">
                            <ng-container [ngTemplateOutlet]="$any(menuTitle())" [ngTemplateOutletContext]="{ $implicit: data() }" />
                        </span>
                    }
                    @else if (menuTitle()) {
                        <span class="vz-menu-title">{{ menuTitle() }}</span>
                    }
                    <ng-container [ngTemplateOutlet]="item.tpl || null" [ngTemplateOutletContext]="{ $implicit: item, click: outerClick(item) }" />
                </ul>
            }
            @else {
                <ul nz-menu>
                    @if (isTpl(menuTitle())) {
                        <span class="vz-menu-title" style="padding: 0">
                            <ng-container [ngTemplateOutlet]="$any(menuTitle())" [ngTemplateOutletContext]="{ $implicit: data() }" />
                        </span>
                    }
                    @else if (menuTitle()) {
                        <span class="vz-menu-title">{{ menuTitle() }}</span>
                    }
                    @if (mItems().length) {
                        <ng-container [ngTemplateOutlet]="menuItemsTpl" [ngTemplateOutletContext]="{ $implicit: mItems() }" />
                        <ng-template let-items #menuItemsTpl>
                            @for (item of items; track $index) {
                                @if (item.children) {
                                    <li nz-submenu class="vz-submenu-correct" [nzDisabled]="item.disabled" (click)="menuItemClick(item, $event)">
                                        <span title>
                                            @if (item.tpl) {
                                                <ng-container [ngTemplateOutlet]="item.tpl" [ngTemplateOutletContext]="{ $implicit: item }" />
                                            }
                                            @else {
                                                @if (item.icon) {
                                                    <i [class]="item.icon"></i>
                                                }
                                                @else if (item.text) {
                                                    <b style="width: 32px; text-align: center">{{ item.text }}</b>
                                                }
                                                <span class="top-2 ml025">{{ item.title }}</span>
                                            }
                                        </span>
                                        <ul>
                                            <ng-container [ngTemplateOutlet]="menuItemsTpl" [ngTemplateOutletContext]="{ $implicit: item.children }" />
                                        </ul>
                                    </li>
                                }
                                @else if (item.id == '-') {
                                    <li nz-menu-divider></li>
                                }
                                @else if (item.tpl) {
                                    <li nz-menu-item [nzDanger]="item.danger" [nzDisabled]="item.disabled" (click)="menuItemClick(item, $event)">
                                        <ng-container [ngTemplateOutlet]="item.tpl" [ngTemplateOutletContext]="{ $implicit: item }" />
                                    </li>
                                }
                                @else {
                                    <li nz-menu-item [nzDanger]="item.danger" [nzDisabled]="item.disabled" (click)="menuItemClick(item, $event)">
                                        @if (item.icon) {
                                            <i [class]="item.icon"></i>
                                        }
                                        @else if (item.text) {
                                            <b style="width: 32px; text-align: center">{{ item.text }}</b>
                                        }
                                        {{ item.title }}
                                    </li>
                                }
                            }
                        </ng-template>
                    }
                </ul>
            }
        </nz-dropdown-menu>

        <ng-template #drawerTpl>
            @if (singleItem(); as item) {
                <div class="layout vertical fit scroll-y gap025">
                    @if (isTpl(menuTitle())) {
                        <span class="vz-menu-title" style="padding: 0">
                            <ng-container [ngTemplateOutlet]="$any(menuTitle())" [ngTemplateOutletContext]="{ $implicit: data() }" />
                        </span>
                    }
                    @else if (menuTitle()) {
                        <span class="vz-menu-title">{{ menuTitle() }}</span>
                    }
                    <ng-container [ngTemplateOutlet]="item.tpl || null" [ngTemplateOutletContext]="{ $implicit: item, click: outerClick(item) }" />
                </div>
            }
            @else if (mItems().length) {
                <div class="layout vertical fit scroll-y gap025">
                    <span class="bg-dd pv05 ph1 fs-xl txt-l tac">
                        @if (isTpl(menuTitle())) {
                            <ng-container [ngTemplateOutlet]="$any(menuTitle())" [ngTemplateOutletContext]="{ $implicit: data() }" />
                        }
                        @else if (menuTitle()) {
                            {{ menuTitle() }}
                        }
                    </span>
                    @for (item of mItems(); track $index) {
                        @if (item.id == '-') {
                            <hr />
                        }
                        @else if (item.tpl) {
                            <ng-container [ngTemplateOutlet]="item.tpl" [ngTemplateOutletContext]="{ $implicit: item }" />
                        }
                        @else {
                            <button style="justify-content: start"
                                nz-button
                                nzType="text"
                                nzSize="large"
                                [nzDanger]="item.danger"
                                [disabled]="item.disabled"
                                (click)="menuItemClick(item)">
                                @if (item.icon) {
                                    <i class="fs-xxl mr1" [class]="item.icon"></i>
                                }
                                @else if (item.text) {
                                    <b style="width: 36px; text-align: left; padding: 1px;">{{ item.text }}</b>
                                }
                                <span class="elli">{{ item.title }}</span>
                            </button>
                        }
                    }
                    <div></div>
                </div>
            }
        </ng-template>
    `,
    imports: [
        NgTemplateOutlet,
        NzDropDownModule, NzDrawerModule, NzButtonModule,
    ]
})
export class ContextMenuComponent implements AfterViewInit, OnDestroy {

    readonly event          = input<MouseEvent | { x: number, y: number }>();
    readonly singleItem     = input<IVzMenuItem>();
    readonly menuItems      = input<IVzMenuItem[]>();
    readonly menuTitle      = input<string | TemplateRef<any>>();
    readonly mobile         = input<boolean>();
    readonly data           = input<any>();
    readonly drawerHeight   = input<number>();

    readonly onItemClick = output<{ mi: IVzMenuItem, data: any, res?: any }>();
    readonly onClose     = output<void>();

    readonly ddMenu      = viewChild.required('ddMenu', { read: NzDropdownMenuComponent });
    readonly drawerTpl   = viewChild.required('drawerTpl', { read: TemplateRef<any> });

    readonly mItems = computed<IVzMenuItem[]>(() => (this.menuItems() || []).filter(v => !v.hidden).filter((v, i, arr) => v.id != '-' || (i > 0 && arr[i -1].id != '-')));

    drawerRef?: NzDrawerRef;
    viewRef?: EmbeddedViewRef<any>;

    private readonly _router     = inject(Router);
    private readonly _menu       = inject(NzContextMenuService);
    private readonly _drawer     = inject(NzDrawerService);

    routerSub = this._router.events.subscribe(e => {
        if (e instanceof NavigationStart) {
            if (this.drawerRef) {
                this.drawerRef.close();
                this.drawerRef = undefined;
                this._router.navigateByUrl(this._router.url, {  replaceUrl: true });
            }
        }
    });

    ngAfterViewInit(): void {
        const items = this.mItems();
        const e = this.event();
        if (this.mobile() || !e) {
            this.drawerRef = this._drawer.create({
                nzClosable: false,
                nzCloseOnNavigation: true,
                nzContent: this.drawerTpl(),
                nzMaskClosable: true,
                nzMask: true,
                nzPlacement: 'bottom',
                nzNoAnimation: false,
                nzWrapClassName: 'context-menu',
                nzHeight: this.singleItem()
                    ? this.drawerHeight()
                    : `min(${items.filter(mi => mi.id != '-').length * 44 + items.filter(mi => mi.id == '-').length * 9 + (this.menuTitle() ? 58 : 20)}px, 90%)`,
            });
            this.drawerRef.afterClose.subscribe(() => {
                // console.log('=[ContextMenuComponent]===> drawerRef.afterClose');
                this.onClose.emit();
            });
        }
        else {
            this.viewRef = this._menu.create(e, this.ddMenu());
            this.viewRef.onDestroy(() => {
                // console.log('=[ContextMenuComponent]===> viewRef.onDestroy');
                setTimeout(() => this.onClose.emit(), 100);
            });
        }
    }

    ngOnDestroy(): void {
        // console.log('=[ContextMenuComponent]===> ngOnDestroy');
        this.routerSub.unsubscribe();
    }

    menuItemClick(mi: IVzMenuItem, e?: MouseEvent, res?: any): void {
        // console.log('=[ContextMenuComponent]===> menuItemClick', mi, e);
        e?.stopImmediatePropagation();
        e?.preventDefault();
        this.close();
        this.onItemClick.emit({ mi, data: this.data(), res });
    }

    outerClick(mi: IVzMenuItem): (res?: any) => void {
        return (res) => this.menuItemClick(mi, undefined, res);
    }

    isTpl(v: any): boolean {
        return v && v instanceof TemplateRef;
    }

    close(): void {
        if (this.drawerRef) {
            this.drawerRef.close();
            this.drawerRef = undefined;
        }
        if (this.viewRef) {
            this.viewRef.destroy();
        }
    }

}
